<template>
    <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
  <footer class="py-5 footer">
    <div class="container">
      <div class="row">
        <div class="mx-auto mb-4 text-center col-lg-8">
          <a
            href="https://addiuva.com/bolivia/"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Addiuva
          </a>
          <a
            href="https://addiuva.com/bolivia/"
            target="_blank"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
            Acerca de Nosotros
          </a>
          <router-link class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0" :to="{name: 'Validacion'}">
            Validar
          </router-link>
          <router-link class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0" :to="{name: 'Contactanos'}">
            Contáctanos
          </router-link>
          <router-link class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0" :to="{name: 'Login'}">
            Acceder
          </router-link>
        </div>
        <div class="mx-auto mt-2 mb-4 text-center col-lg-8">
          <div>SÍGUENOS</div>
          <label style="padding-right: 8px"
            >Se parte de nuestra comunidad</label
          >
          <a href="#" target="_black"
            ><i
              class="fab fa-facebook-square fa-2x"
              style="color: #8b46cd"
            ></i
          ></a>
          <a
            href="#"
            target="_black"
            style="padding-left: 4px; padding-right: 4px"
            ><i class="fab fa-linkedin fa-2x" style="color: #8b46cd"></i
          ></a>
          <a href="#" target="_black"
            ><i
              class="fab fa-instagram-square fa-2x"
              style="color: #8b46cd"
            ></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright © {{ new Date().getFullYear() }} Development by
            <a
              href="#"
              class="font-weight-bold"
              target="_blank"
              >tchiri</a
            >
            and
            <a
              href="#"
              class="font-weight-bold"
              target="_blank"
              >rnina</a
            >.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
